import { Icon } from "@/components/Icon"

interface QaThinkingProps {
  progressLog?: string[]
}

const DEFAULT_LABEL = "Researching your question…"

export function QaThinking({ progressLog = [] }: QaThinkingProps) {
  const steps = progressLog.length > 0 ? progressLog : [DEFAULT_LABEL]

  return (
    <div className="thinking">
      <ul className="thinking__stream">
        {steps.map((label, i) => {
          const isLive = i === steps.length - 1
          return (
            <li className={`thought${isLive ? " is-live" : ""}`} key={`${i}-${label}`}>
              <span className="thought__mark">
                {isLive ? (
                  <span className="thought__pulse" />
                ) : (
                  <Icon name="check" size={13} className="tick" />
                )}
              </span>
              <div className="thought__body">
                <span className="thought__label">{label}</span>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
